module.exports = __webpack_public_path__ + "img/1,w_1400.07a2e08d.jpg";